import { defineComponent as _defineComponent } from 'vue'
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
import AzLogo from '~/assets/images/icons/logos/aroma-zone.svg?inline';

export default /*#__PURE__*/_defineComponent({
  __name: 'Logo',
  setup(__props) {


return { __sfc: true,NuxtLinkCustom, AzLogo }
}

})